import { getLocationParam } from "@/utils/url";

export type ChartEngine = "adv" | "tw";

export const getChartEngine = (): ChartEngine => {
    const g = getLocationParam("g");
    return g === "adv" ? "adv" : "tw";
};

export const useChartEngine = (): ChartEngine => {
    return getChartEngine();
};
